/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UserRoleEnum =
  | 'BUYER_DIRECTOR'
  | 'BUYER_FINANCE'
  | 'BUYER_MANAGER'
  | 'BUYER_OWNER'
  | 'COMPANY_ADMIN'
  | 'STAFF_ADMIN'
  | 'SUPPLIER_OWNER'
  | 'SUPPLIER_SALES_ADMIN'
  | 'SUPPLIER_SALES_REP';

export type DeleteRoleAssignmentMutationVariables = Exact<{
  userId: string;
  companyId: string;
  role: Types.UserRoleEnum;
}>;


export type DeleteRoleAssignmentMutation = { companyControllerDeleteRoleAssignment: string };


export const DeleteRoleAssignmentDocument = /*#__PURE__*/ gql`
    mutation deleteRoleAssignment($userId: String!, $companyId: String!, $role: UserRoleEnum!) {
  companyControllerDeleteRoleAssignment(
    roleAssignmentInputDTOInput: {userId: $userId, role: $role}
    companyId: $companyId
  )
}
    `;
export type DeleteRoleAssignmentMutationFn = Apollo.MutationFunction<DeleteRoleAssignmentMutation, DeleteRoleAssignmentMutationVariables>;

/**
 * __useDeleteRoleAssignmentMutation__
 *
 * To run a mutation, you first call `useDeleteRoleAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleAssignmentMutation, { data, loading, error }] = useDeleteRoleAssignmentMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      companyId: // value for 'companyId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useDeleteRoleAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoleAssignmentMutation, DeleteRoleAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoleAssignmentMutation, DeleteRoleAssignmentMutationVariables>(DeleteRoleAssignmentDocument, options);
      }
export type DeleteRoleAssignmentMutationHookResult = ReturnType<typeof useDeleteRoleAssignmentMutation>;
export type DeleteRoleAssignmentMutationResult = Apollo.MutationResult<DeleteRoleAssignmentMutation>;
export type DeleteRoleAssignmentMutationOptions = Apollo.BaseMutationOptions<DeleteRoleAssignmentMutation, DeleteRoleAssignmentMutationVariables>;